import { render } from "./Mytrips.vue?vue&type=template&id=f00e2346"
import script from "./Mytrips.vue?vue&type=script&lang=js"
export * from "./Mytrips.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__